// Triggers a browser save-as for a Blob response (e.g. a CSV export),
// without needing a plain <a href> to the API (which can't carry the
// Authorization header these endpoints require).
export function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
}
